import { render, staticRenderFns } from "./CompoundSelector.vue?vue&type=template&id=4471e6a8&scoped=true&"
import script from "./CompoundSelector.vue?vue&type=script&lang=js&"
export * from "./CompoundSelector.vue?vue&type=script&lang=js&"
import style0 from "./CompoundSelector.vue?vue&type=style&index=0&id=4471e6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4471e6a8",
  null
  
)

export default component.exports